import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import styled from 'styled-components';
import { LogoText, FooterText } from '../styles/typography';
import MessageBubble from './MessageBubble';
import FontWarningBar from './FontWarningBar';
import logo from '../assets/logo.png';
import daySendIcon from '../assets/day-send.png';
import nightSendIcon from '../assets/night-send.png';
import atachIcon from '../assets/atach-icon.png';
import toolIcon from '../assets/tool-icon.png';
import makePhoto from '../assets/makePhoto-icon.png';
import files from '../assets/file-icon.png';
import voiceIcon from '../assets/voice-icon.png';
import voiceChatIcon from '../assets/voiceChat-icon.png';
import menuIcon from '../assets/menu-icon.png';
import newSessionIcon from '../assets/newSession-icon.png';
import newSessionNightIcon from '../assets/newSessionNight-icon.png';
import libraryIcon from '../assets/library-icon.png';
import exploreIcon from '../assets/explore-icon.png';
import teachIcon from '../assets/teach-icon.png';
import thinkIcon from '../assets/think-icon.png';
import searchWebIcon from '../assets/searchWeb-icon.png';
import deepSearchIcon from '../assets/deepSearch-icon.png';
import createImageIcon from '../assets/createImage-icon.png';
import photosIcon from '../assets/photos-icon.png';
import logoWithText from '../assets/logoWithText.png';
import themIcon from '../assets/them-icon.png';
import fontIcon from '../assets/font-icon.png';
import shopIcon from '../assets/shop-icon.png';
import hobyIcon from '../assets/hoby-icon.png';
import psyIcon from '../assets/psy-icon.png';
import accountIcon from '../assets/account-icon.png';




const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between; // یا حتی center اگر خواستی همه وسط باشن
  width: 100%;
  padding: 0.2rem 0.5rem 0.7rem 0.5rem;
  margin-bottom: 0.5rem;
  position: relative;
  z-index: 2;

  @media (max-width: 600px) {
    padding: 0.1rem 0.1rem 0.3rem 0.1rem;
    margin-bottom: 0.3rem;
  }
`;

const HeaderIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 0.7rem;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100vh;
  min-height: 0;
  padding: 1rem;
  font-family: inherit;

  @media (max-width: 600px) {
    overflow: auto;
    padding: 0.5rem 0.2rem;
    height: 100dvh;
    min-height: 0;
  }
`;

const NewSessionButton = styled.button`
  position: fixed;
  top: 1rem;
  left: 1rem;
  z-index: 1001;
  width: 48px;
  height: 48px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;

  @media (max-width: 600px) {
    left: 1rem;
    width: 40px;
    height: 40px;
    top: 0.5rem;
  }
`;



const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.5rem;

  img {
    width: 100px;
  }

  ${LogoText} {
    font-size: 1.5rem;
    margin-top: 0.0rem;
  }

  @media (max-width: 600px) {
    margin-bottom: 0.7rem;
    img {
      width: 70px;
    }
    ${LogoText} {
      font-size: 1rem;
      margin-top: 0.0rem;
    }
  }
`;



const ChatBox = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
  direction: rtl;
  text-align: right;
  margin-bottom: 1rem;
  background: ${({ isNight }) =>
    isNight
      ? 'rgba(0, 0, 0, 0.00)'
      : 'rgba(255, 255, 255, 0.07)'};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.00);
  backdrop-filter: blur(1px);
  -webkit-backdrop-filter: blur(18px);
  border: 0px solid rgba(0, 0, 0, 0.00);

  @media (max-width: 600px) {
    padding: 0.4rem;
    margin-bottom: 0.4rem;
    border-radius: 10px;
    gap: 0.4rem;
  }
`;



const InputWrapper = styled.div`
  width: 100%;
  margin-bottom: 0; 
`;

const InputBox = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;

  @media (max-width: 600px) {
    gap: 0.2rem;
    margin-bottom: 0.04rem;
  }
`;

const TextInputBox = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  height: 48px;
  background: ${({ isNight }) => (isNight ? '#333' : '#f0f0f0')};
  border-radius: 999px;
  padding: 0 1rem;

  @media (max-width: 600px) {
    height: 48px;         
    padding: 0 0.7rem;
    border-radius: 999px;
  }
`;


const TextInput = styled.input`
  width: 100%;
  background: transparent;
  border: none;
  font-size: 1rem;
  height: 100%;
  min-height: 0;
  color: ${({ isNight }) => (isNight ? '#fff' : '#000')};
  outline: none;
  font-family: inherit;
`;

const SendButton = styled.button`
  width: 45px;
  height: 45px;
  border-radius: 999px;
  margin-left: -0.5rem;  // For spacing
  background: none;     // No background if you want icon-only
  background-color: transparent;
  background-image: url(${({ isNight }) => (isNight ? nightSendIcon : daySendIcon)});
  background-size: cover;
  background-position: center;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;   

  @media (max-width: 600px) {
    width: 45px;
    height: 45px;
    border-radius: 999px;
  }
`;


const FooterActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  align-items: center;
  justify-content: space-between;
  gap: 0.7em;
  width: 100%;
  padding-left: 0;
  direction: rtl;

  @media (max-width: 600px) {
    gap: 0.2rem;
    padding-left: 0;
    
  }
`;




const ToolWrapper = styled.div`
display: flex;
position: relative;
padding: 0;
font-family: unset !important;
`;

const AttachmentWrapper = styled.div`
display: flex;
position: relative;
padding: 0;
font-family: unset !important;
`;

const MenuToggleButton = styled.button`
  display: flex;
  position: relative;
  top: 1rem;
  right: ${({ sidebarOpen }) => (sidebarOpen ? '350px' : '0px')};
  z-index: 1001;
  width: 48px;
  height: 48px;
  background-color: transparent;
  background-image: url(${menuIcon});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  transform: ${({ sidebarOpen }) => (sidebarOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  filter: ${({ isNight }) => (isNight ? 'invert(1)' : 'none')};

  @media (max-width: 600px) {
    right: ${({ sidebarOpen }) => (sidebarOpen ? '70vw' : '1rem')};
    width: 40px;
    height: 40px;
    top: 0.5rem;
  }
`;

const ToolToggle = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: unset !important;
`;

const AttachmentToggle = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: unset !important;
`;

const ToolMenu = styled.div`
  position: absolute;
  bottom: 40px;
  right: 0;
  background: ${({ isNight }) => (isNight ? '#333' : '#f0f0f0')};
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
  padding: 0.5rem;
  z-index: 10;
  width: 250px; 
  
  @media (max-width: 600px) {
    width: 250px;
    padding: 0.3rem;
    font-size: 0.9rem;
  }

`;

const AttachmentMenu = styled.div`
  position: absolute;
  bottom: 40px;
  right: 0;
  background: ${({ isNight }) => (isNight ? '#333' : '#f0f0f0')};
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
  padding: 0.5rem;
  z-index: 10;
  width: 250px;

  @media (max-width: 600px) {
    width: 130px;
    padding: 0.3rem;
    font-size: 0.9rem;
  }
`;

const AccountMenu = styled.div`
  position: absolute;
  top: 40px;
  right: 95%;
  background: ${({ isNight }) => (isNight ? '#333' : '#f0f0f0')};
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
  padding: 0.5rem;
  z-index: 10;
  width: 250px; 
  
  @media (max-width: 600px) {
    width: 250px;
    padding: 0.3rem;
    font-size: 0.9rem;
  }

`;

const DropdownMenu = styled.div`
  position: absolute;
  bottom: 120px;
  right: 95%;
  min-width: 180px;
  background: ${({ isNight }) => (isNight ? '#333' : '#f0f0f0')};
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
  padding: 0.5rem;
  z-index: 1111;
  width: 250px; 
  
  @media (max-width: 600px) {
    width: 250px;
    padding: 0.3rem;
    font-size: 0.9rem;
  }

`;

const AttachmentItem = styled.button`
  width: 100%;
  display: flex;
  text-align: right;
  gap: 8px;
  align-items: center;
  background: none;
  border: none;
  padding: 6px 12px;
  font-family: inherit;
  font-size: 0.95rem;
  color: inherit;
  cursor: pointer;

  &:hover {
    background: ${({ isNight }) => (isNight ? '#444' : '#ddd')};
  }
`;


const ToolItem = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: right;
  background: none;
  border: none;
  border-radius: 8px;
  padding: 6px 12px;
  margin-bottom: 0.3rem;
  font-family: inherit;
  font-size: 1rem;
  color: inherit;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: ${({ isNight }) => (isNight ? '#444' : '#e6e6e6')};
  }
`


const SidebarItem = styled.button`
  width: 100%;
  display: flex;
  text-align: right;
  align-items: center;
  gap: 0px;
  margin-top: 0rem;
  margin-bottom: 0rem;
  background: none;
  border: none;
  border-radius: 7px;
  padding: 6px 15px;
  font-family: inherit;
  font-size: 0.92rem;
  color: inherit;
  cursor: pointer;

  &:hover {
    background: ${({ isNight }) => (isNight ? '#444' : '#ddd')};
  }

  @media (max-width: 600px) {
    font-size: 0.8rem;
    padding: 0.22rem 0.4rem;
    gap: 0.18em;
  }
`;

const FontMenu = styled.div`
  position: absolute;
  bottom: 60%;
  right: 105%;
  background: ${({ isNight }) => (isNight ? '#333' : '#f0f0f0')};
  border-radius: 10px;
  padding: 0.5rem;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  z-index: 20;
  width: 250px;

  @media (max-width: 600px) {
    left: 105%;
    padding: 0.3rem;
    font-size: 0.9rem;
    width: 110px;
  }
`;

const FontMenuItem = styled.button`
  background: none;
  border: none;
  padding: 0.4rem 1rem;
  width: 100%;
  text-align: right;
  font-size: 0.95rem;
  font-family: inherit;
  color: inherit;
  cursor: pointer;

  &:hover {
    background: ${({ isNight }) => (isNight ? '#444' : '#ddd')};
  }
`;



const Sidebar = styled.div`
  position: fixed;
  top: 0;
  right: ${({ open }) => (open ? '0' : '-350px')};
  width: 350px;
  height: 100%;
  background: ${({ isNight }) => (isNight ? '#111' : '#fafafa')};
  color: ${({ isNight }) => (isNight ? '#fff' : '#000')};
  border-left: 1px solid ${({ isNight }) => (isNight ? '#333' : '#ccc')};
  box-shadow: -2px 0 5px rgba(0,0,0,0.2);
  transition: right 0.3s ease;
  padding: 2rem 1rem 1rem 1rem;
  z-index: 1000;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
  display: flex;
  flex-direction: column;

  @media (max-width: 600px) {
    width: 70vw;
    right: ${({ open }) => (open ? '0' : '-85vw')};
    padding: 1.5rem 0.5rem 0.5rem 0.5rem;
    border-radius: 0;
    font-size: 0.98rem;
  }
`;

const SearchInput = styled.input`
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding: 0.6rem 1rem;
  border-radius: 999px;
  border: 1px solid ${({ isNight }) => (isNight ? '#555' : '#ccc')};
  background-color: ${({ isNight }) => (isNight ? '#222' : '#fff')};
  color: ${({ isNight }) => (isNight ? '#fff' : '#000')};
  font-size: 1rem;
  font-family: inherit;
  outline: none;

  &::placeholder {
    color: ${({ isNight }) => (isNight ? '#aaa' : '#888')};
  }
`;

const SubToolMenu = styled.div`
  position: absolute;
  bottom: 0;     // برای چپ یا راست دقیقتر می‌تونی تغییر بدی (مثلاً right: -250px)
  right: 100%;
  background: ${({ isNight }) => (isNight ? '#333' : '#f0f0f0')};
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
  padding: 0.5rem;
  z-index: 20;
  width: 300px;
`;

const SidebarSession = styled.button`
  width: 100%;
  display: flex;
  text-align: right;
  align-items: center;
  gap: 8px;
  margin-top: 0rem;
  margin-bottom: 0rem;
  background: none;
  border: none;
  border-radius: 999px; /* خیلی مهم! برای کپسولی */
  padding: 10px 20px;   /* فاصله افقی بیشتر برای حالت کپسولی */
  font-family: inherit;
  font-size: 0.92rem;
  color: inherit;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
  border: 1.2px solid #949494ff;

  &:hover {
    background: ${({ isNight }) => (isNight ? '#444' : '#ddd')};
    box-shadow: 0 1px 8px 0 rgba(90,85,255,0.08);
  }

  ${({ selected, isNight }) =>
    selected &&
    `
      background: ${isNight ? '#333' : '#eee'};
      color: ${isNight ? '#fff' : '#111'};
      box-shadow: 0 2px 12px 0 rgba(90,85,255,0.14);
      border: 1.5px solid #5A55FF;
    `
  }

  @media (max-width: 600px) {
    font-size: 0.8rem;
    padding: 0.35rem 0.9rem;
    gap: 0.18em;
  }
`;

const SessionsScrollBox = styled.div`
  max-height: 48vh;
  overflow-y: auto;
  direction: rtl;
  @media (max-width: 600px) {
    max-height: 30vh;
  }
`;



async function authFetch(url, options = {}, retry = true) {
  const access_token = localStorage.getItem('access_token');
  const refresh_token = localStorage.getItem('refresh_token');

  const headers = {
    ...(options.headers || {}),
    'Authorization': `Bearer ${access_token}`,
    'Content-Type': 'application/json'
  };

  try {
    const res = await fetch(url, { ...options, headers });

    if (res.status !== 401 || !retry) {
      return res;
    }

    // If 401 → try refreshing the access token
    const refreshRes = await fetch('/api/auth/refresh', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${refresh_token}`
      }
    });

    if (!refreshRes.ok) {
      throw new Error("Refresh token invalid");
    }

    const refreshData = await refreshRes.json();
    localStorage.setItem('access_token', refreshData.access_token);

    // Retry original request with new access token
    headers['Authorization'] = `Bearer ${refreshData.access_token}`;
    return await fetch(url, { ...options, headers });

  } catch (err) {
    console.error('authFetch error:', err);
    // Clear local storage and redirect to login
    localStorage.clear();
    window.location.href = "/login"; // or navigate("/login") if using React Router
    throw err;
  }
}


const ChatWindow = ({
  isNight,
  setIsNight,
  access_token,
  user_id
}) => {
  const navigate = useNavigate();
  const [currentLang, setCurrentLang] = useState('en');
  const [selectedFont, setSelectedFont] = useState('Great Vibes');
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [fontAccepted, setFontAccepted] = useState(false);
  const [attachmentOpen, setAttachmentOpen] = useState(false);
  const [searchWebOpen, setsearchWebOpen] = useState(false);
  const [deepSearchOpen, setDeepSearchOpen] = useState(false);
  const [hobyOpen, sethobyOpen] = useState(false);

  const [toolsOpen, setToolsOpen] = useState(false);
  const [fontMenuOpen, setFontMenuOpen] = useState(false);
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const [loading, setLoading] = useState(false);
  const chatEndRef = useRef(null);

  const chatRef = useRef(null);
  const attachmentRef = useRef(null);
  const searchWebRef = useRef(null);
  const hobyRef = useRef(null);
  const toolsRef = useRef(null);
  const fontMenuRef = useRef(null);
  const accountMenuRef = useRef(null);
  const attachmentButtonRef = useRef(null);
  const searchWebButtonRef = useRef(null);
  const hobyButtonRef = useRef(null);
  const toolsButtonRef = useRef(null);
  const fontButtonRef = useRef(null);
  const accountButtonRef = useRef(null);

  const [hasSentMessage, setHasSentMessage] = useState(false);

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const sidebarRef = useRef(null);
  const toggleButtonRef = useRef(null);

  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);

  const [welcomeTimeoutId, setWelcomeTimeoutId] = useState(null);
  const welcomeMessageRef = useRef(null); 
  const introMessageRef = useRef(null); 

  const [shopMenuOpen, setShopMenuOpen] = useState(false);
  const shopMenuRef = useRef(null);
  const shopButtonRef = useRef(null);



  const handleLogout = () => {
  localStorage.clear();
  window.location.reload();
  };



  const fetchSessionMessages = async (sid) => {
  try {
    const res = await authFetch('/api/chat/history', {
      method: 'POST',
      body: JSON.stringify({ session_id: sid }),});
    const historyData = await res.json();
    const historyMsgs = Array.isArray(historyData)
      ? historyData.flatMap(msg => ([
          { sender: 'user', text: msg.user_message },
          { sender: 'bot', text: msg.bot_response }
        ]))
      : [];

      

    setMessages(historyMsgs);
    
    

  

  } catch (err) {
    setMessages([{ sender: 'bot', text: 'مشکل در بارگذاری پیام‌ها' }]);
  }
};

  
  const handleSelectSession = (sid) => {
    setSelectedSession(sid);
    fetchSessionMessages(sid);
  };

  useEffect(() => {
    const access_token = localStorage.getItem('access_token');
    const user_id = localStorage.getItem('user_id');
    const session_id = localStorage.getItem('session_id');

    if (!access_token) return;


    const fetchInitialMessages = async () => {
      try {
        
        // 2. Fetch history
        const historyRes = await authFetch(`/api/chat/history`, {
          method: 'POST',
          body: JSON.stringify({session_id: session_id}),
        });
        const historyData = await historyRes.json();
        const historyMsgs = Array.isArray(historyData)
        ? historyData.flatMap(msg => ([
            { sender: 'user', text: msg.user_message },
            { sender: 'bot', text: msg.bot_response }
          ]))
        : [];

        setMessages(historyMsgs);


        const welcomeRes = await authFetch(`/api/chat/welcome`, {
          method: 'POST'
        });
        const welcomeData = await welcomeRes.json();
        welcomeMessageRef.current = { sender: 'bot', text: welcomeData.message };
        
        if (!welcomeData.first_time) {
          const timeoutId = setTimeout(() => {
            setMessages(prev => [...prev, welcomeMessageRef.current]);
          }, 3000);
          setWelcomeTimeoutId(timeoutId);
        } else {
          const introRes = await authFetch(`/api/welcome`, {
            method: 'POST'
          });
          const introData = await introRes.json();
          introMessageRef.current = { sender: 'bot', text: introData.message };
          setMessages(prev => [...prev, introMessageRef.current]);
          // اگر اولین بار است سریعاً پیام رو نمایش بده
          setMessages(prev => [...prev, welcomeMessageRef.current]);
        }


      } catch (err) {
        setMessages([{ sender: 'bot', text: 'مشکل در بارگذاری پیام‌ها' }]);
      }
    };

    fetchInitialMessages();

    return () => {
      if (welcomeTimeoutId) clearTimeout(welcomeTimeoutId);
    };
  }, []);
  




  useEffect(() => {
    chatRef.current?.scrollTo(0, chatRef.current.scrollHeight);
  }, [messages]);

  useEffect(() => {
    
    const closeAllMenus = (event) => {
      if (
        attachmentRef.current &&
        !attachmentRef.current.contains(event.target) &&
        attachmentButtonRef.current &&
        !attachmentButtonRef.current.contains(event.target)
      ) setAttachmentOpen(false);

      if (
        searchWebRef.current &&
        !searchWebRef.current.contains(event.target) &&
        searchWebButtonRef.current &&
        !searchWebButtonRef.current.contains(event.target)
      ) setsearchWebOpen(false);

      if (
        hobyRef.current &&
        !hobyRef.current.contains(event.target) &&
        hobyButtonRef.current &&
        !hobyButtonRef.current.contains(event.target)
      ) sethobyOpen(false);

      if (
        toolsRef.current &&
        !toolsRef.current.contains(event.target) &&
        toolsButtonRef.current &&
        !toolsButtonRef.current.contains(event.target)
      ) setToolsOpen(false);

      if (
        fontMenuRef.current &&
        !fontMenuRef.current.contains(event.target) &&
        fontButtonRef.current &&
        !fontButtonRef.current.contains(event.target)
      ) setFontMenuOpen(false);

      if (
        accountMenuRef.current &&
        !accountMenuRef.current.contains(event.target) &&
        accountButtonRef.current &&
        !accountButtonRef.current.contains(event.target)
      ) setAccountMenuOpen(false);

      if (
        shopMenuRef.current &&
        !shopMenuRef.current.contains(event.target) &&
        shopButtonRef.current &&
        !shopButtonRef.current.contains(event.target)
      ) setShopMenuOpen(false);

    };

    document.addEventListener('mousedown', closeAllMenus);
    return () => document.removeEventListener('mousedown', closeAllMenus);
  }, []);

  useEffect(() => {
      const handleClickOutside = (event) => {
        if (
            sidebarRef.current &&
            !sidebarRef.current.contains(event.target) &&
            toggleButtonRef.current &&
            !toggleButtonRef.current.contains(event.target)
            ) {
          setSidebarOpen(false);
        }
  
      };
  
      if (sidebarOpen) {
        document.addEventListener('mousedown', handleClickOutside);
      } else {
        document.removeEventListener('mousedown', handleClickOutside);
      }
  
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [sidebarOpen]);

    useEffect(() => {
      if (sidebarOpen) {
        const fetchSessions = async () => {
          const access_token = localStorage.getItem('access_token');
          const res = await fetch('/api/chat/sessions', {
            headers: {
              'Authorization': `Bearer ${access_token}`
            }
          });
          const data = await res.json();
          console.log("sessions data:", data);
          setSessions(data.sessions || []);
        };
        fetchSessions();
      }
    }, [sidebarOpen]);

  
  

  const handleSend = async () => {
    if (welcomeTimeoutId) {
      clearTimeout(welcomeTimeoutId);
      setWelcomeTimeoutId(null);
    }


    if (!input.trim()) return;
    setHasSentMessage(true);

    const userMessage = input;
    setMessages(prev => [
      ...prev,
      { sender: 'user', text: userMessage },
      { sender: 'bot', text: 'در حال پاسخ...' }
    ]);
    setInput('');
    setLoading(true);
    try {
      const access_token = localStorage.getItem('access_token');
      const session_id = localStorage.getItem('session_id');

      const res = await authFetch('/api/chat/send', {
        method: 'POST',
        body: JSON.stringify({ message: userMessage ,
                               session_id: session_id}),
      });
      if (!res.ok) throw new Error('خطا در پاسخ سرور');
      const data = await res.json();
      setMessages(prev => {
        const newMessages = [...prev];
        newMessages[newMessages.length - 1] = { sender: 'bot', text: data.reply || 'پاسخ خالی!' };
        return newMessages;
      });
    } catch (error) {
      setMessages(prev => {
        const newMessages = [...prev];
        newMessages[newMessages.length - 1] = { sender: 'bot', text: 'خطا در پاسخ از سرور' };
        return newMessages;
      });
    } finally {
      setLoading(false);
    }
  };
  
  
  const isDecorativeFont = selectedFont === 'Great Vibes';
  
  return (
    <Container isNight={isNight} style={{ fontFamily: selectedFont }}>
      <Header>

        <MenuToggleButton
          ref={toggleButtonRef}
          sidebarOpen={sidebarOpen}
          isNight={isNight}
          onClick={() => setSidebarOpen(!sidebarOpen)}
          style={{ marginLeft: 0,
             padding: 0,
             marginRight: 0,
             top: 'unset',
           }}
        />

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0
        }}>
          <img src={logo} alt="logo"
            style={{
              filter: isNight ? 'invert(1)' : 'none',
              width: 90,
              marginBottom: 0
            }} 
          />
          <LogoText style={{
            color: isNight ? '#fff' : '#000',
            fontFamily: "'Allura', cursive",
            fontSize: '1.5rem',
            margin: 0
          }}>Jimi</LogoText>
        </div>

        <NewSessionButton
          aria-label="New Session"
          onClick={async () => {
            const res = await authFetch('/api/chat/new_session', { method: 'POST' });
            const data = await res.json();
            if (data.session_id) {
              localStorage.setItem('session_id', data.session_id);
              window.location.reload();
            }
          }}
          isNight={isNight}
          style={{ position: 'static', left: 'unset', top: 'unset', marginRight: 0 }}
        >
          <img
            src={isNight ? newSessionNightIcon : newSessionIcon}
            alt="new session"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              filter: 'none',
              display: 'block'
            }}
          />
        </NewSessionButton>
      </Header>

      



      

      <Sidebar ref={sidebarRef} isNight={isNight} open={sidebarOpen}>
        <SidebarItem isNight={isNight} ref={accountButtonRef} onClick={() => setAccountMenuOpen(prev => !prev)} style={{
          marginBottom: '0.5rem', justifyContent: 'flex-start',fontWeight: 'bold',
        }}>
          <img
            src={accountIcon}
            alt="account"
            style={{
              width: 40,
              marginLeft: 6,
              filter: isNight ? 'invert(1)' : 'none',
              display: 'inline-block',
              objectFit: 'contain'
            }}
          />
          {currentLang === 'fa' ? localStorage.getItem("name") : localStorage.getItem("name")}
          {accountMenuOpen && (
            <AccountMenu isNight={isNight} ref={accountMenuRef} style={{
                                                                  direction: currentLang === "fa" ? "rtl" : "ltr",
                                                                  textAlign: currentLang === "fa" ? "right" : "left",
                                                                  display: 'block'
                                                                }}>
              <SidebarItem isNight={isNight} onClick={() => {
                setAccountMenuOpen(false); // منو رو ببند
                navigate("/account"); // برو به صفحه حساب
              }}>
                {currentLang === 'fa' ? "حساب کاربری" : "Account"}
              </SidebarItem>
              <SidebarItem isNight={isNight} onClick={handleLogout} style={{
                                              marginBottom: '0.5rem',
                                              justifyContent: 'flex-start',
                                              fontWeight: 'bold',
                                              position: 'relative',
                                              direction: currentLang === "fa" ? "rtl" : "ltr",
                                              textAlign: currentLang === "fa" ? "right" : "left",
                                              display: 'block'
                                            }}>
                {currentLang === 'fa' ? "خروج" : "Logout"}
              </SidebarItem>
            </AccountMenu>
          )}
        </SidebarItem>
        {sessions && (
          <div style={{ marginBottom: '1.2rem', marginTop: '0.5rem' }}>
            <div style={{
              fontWeight: 'bold',
              fontSize: '1.04rem',
              marginBottom: '0.3rem',
              color: isNight ? '#fff' : '#222',
              paddingRight: 3,
              direction: currentLang === "fa" ? "rtl" : "ltr",
              textAlign: currentLang === "fa" ? "right" : "left",
              display: 'block'
            }}>
              {currentLang === 'fa' ? 'تاریخجه گفت‌وگوها' : 'Chats history'}
            </div>
            <div style={{
              border: isNight ? '1.5px solid #444' : '1.5px solid #c0c0c0',
              borderRadius: 13,
              padding: '0.7rem 0.3rem',
              background: isNight ? '#181818' : '#f5f5f5',
              boxShadow: isNight ? '' : '0 1px 7px 0 #0001',
            }}>
              <SessionsScrollBox>
                <ul style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  overflowY: 'auto',
                  display: 'block',
                }}>
                  {sessions.map(session => (
                    <li key={session.session_id}>
                      <SidebarSession
                        isNight={isNight}
                        selected={selectedSession === session.session_id}
                        onClick={() => handleSelectSession(session.session_id)}
                      >
                        <span style={{
                          fontSize: '0.98em',
                          opacity: 0.94,
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          Height: '300px',
                          Width: 200,
                          direction: 'rtl'
                        }}>
                          {session.first_message ? session.first_message.slice(0, 36) + '...' : ''}
                        </span>
                      </SidebarSession>
                    </li>
                  ))}
                </ul>
              </SessionsScrollBox>
            </div>
          </div>

        )}
        

        <SidebarItem isNight={isNight} style={{
          marginBottom: '0rem', justifyContent: 'flex-start',fontWeight: 'bold', marginTop: "auto", fontSize: '1rem'
        }}>
          <img
            src={logoWithText}
            alt="logo"
            style={{
              width: 45,
              marginLeft: 4,
              marginRight:0,
              filter: isNight ? 'invert(1)' : 'none',
              display: 'inline-block',
              objectFit: 'contain',
              direction: currentLang === "fa" ? "rtl" : "ltr",
              textAlign: currentLang === "fa" ? "right" : "left",
              display: 'block'
            }}
          />
          {currentLang === 'fa' ? "JIMI" : "JIMI"}
        </SidebarItem>
        <SidebarItem isNight={isNight} ref={shopButtonRef}  onClick={() => setShopMenuOpen(prev => !prev)} style={{
          marginBottom: '0rem', justifyContent: 'flex-start'
        }}>
          <img
            src={shopIcon}
            alt="shopIcon"
            style={{
              width: 40,
              marginLeft: 6,
              filter: isNight ? 'invert(1)' : 'none',
              display: 'inline-block',
              objectFit: 'contain',
              direction: currentLang === "fa" ? "rtl" : "ltr",
              textAlign: currentLang === "fa" ? "right" : "left",
              display: 'block'
            }}
          />
          {currentLang === 'fa' ? "خرید" : "Shopping"}
          {shopMenuOpen && (
            <DropdownMenu isNight={isNight} ref={shopMenuRef}>
              <SidebarItem
                isNight={isNight}
                onClick={() => window.open('https://digikala.com', '_blank')}
              >
                دیجی‌کالا
              </SidebarItem>
              <SidebarItem
                isNight={isNight}
                onClick={() => window.open('https://alibaba.ir', '_blank')}
              >
                علی‌بابا
              </SidebarItem>
              <SidebarItem
                isNight={isNight}
                onClick={() => window.open('https://amazon.com', '_blank')}
              >
                آمازون
              </SidebarItem>
            </DropdownMenu>
          )}
        </SidebarItem>
        <SidebarItem isNight={isNight} style={{
          marginBottom: '0rem', justifyContent: 'flex-start'
        }}>
          <img
            src={exploreIcon}
            alt="exploreIcon"
            style={{
              width: 45,
              marginLeft: 6,
              filter: isNight ? 'invert(1)' : 'none',
              display: 'inline-block',
              objectFit: 'contain',
              direction: currentLang === "fa" ? "rtl" : "ltr",
              textAlign: currentLang === "fa" ? "right" : "left",
              display: 'block'
            }}
          />
          {currentLang === 'fa' ? "JIMIها را کاوش کنید" : "Explore JIMIs"}
        </SidebarItem>
        <SidebarItem isNight={isNight} style={{
          marginBottom: '0rem', justifyContent: 'flex-start'
        }}>
          <img
            src={libraryIcon}
            alt="libraryIcon"
            style={{
              width: 45,
              marginLeft: 6,
              filter: isNight ? 'invert(1)' : 'none',
              display: 'inline-block',
              objectFit: 'contain',
              direction: currentLang === "fa" ? "rtl" : "ltr",
              textAlign: currentLang === "fa" ? "right" : "left",
              display: 'block'
            }}
          />
          {currentLang === 'fa' ? "کتابخانه‌ها" : "Libraries"}
        </SidebarItem>
        <SearchInput
          isNight={isNight}
          placeholder="جستجو..."
          onChange={(e) => console.log("جستجو:", e.target.value)}
        />
      </Sidebar>
      

      <ChatBox ref={chatRef} isNight={isNight}>
        {messages.map((msg, idx) => (
          <MessageBubble
            key={idx}
            sender={msg.sender}
            text={msg.text}
            isNight={isNight}
          />
        ))}
      </ChatBox>

      <InputWrapper>
        {isDecorativeFont && !fontAccepted && (
          <FontWarningBar
            onAccept={() => setFontAccepted(true)}
            onChange={() => setSelectedFont('Vazir')}
          />
        )}

        <InputBox>
          <TextInputBox isNight={isNight}>
            <TextInput
              isNight={isNight} 
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSend()}
              style={{ flex: 1, direction: currentLang === "fa" ? "rtl" : "ltr", textAlign: currentLang === "fa" ? "right" : "left", display: 'block' }}
              placeholder={currentLang === 'fa' ? "پیام خود را وارد کنید..." : "Type your message..."}
            />
            <SendButton isNight={isNight} onClick={handleSend} />
          </TextInputBox>
        </InputBox>

        <FooterActions>
          
          <div style={{ display: 'flex', gap: '0.7rem' }}>

            <AttachmentWrapper>
              <AttachmentToggle ref={attachmentButtonRef} onClick={() => setAttachmentOpen(prev => !prev)}>
                <img src={atachIcon} alt="attach" style={{width: 33,objectFit: "contain", filter: isNight ? 'invert(1)' : 'none'}}/>              
              </AttachmentToggle>
              {attachmentOpen && (
                <AttachmentMenu isNight={isNight} ref={attachmentRef}>
                  <AttachmentItem isNight={isNight} >
                    <img
                      src={photosIcon}
                      alt="photos"
                      style={{
                        width: 40,
                        marginLeft: 6,
                        marginRight: currentLang === 'fa' ? 0 : 8,
                        marginLeft: currentLang === 'fa' ? 8 : 0,
                        filter: isNight ? 'invert(1)' : 'none',
                        display: 'inline-block',
                        objectFit: 'contain',
                        direction: currentLang === "fa" ? "rtl" : "ltr",
                        textAlign: currentLang === "fa" ? "right" : "left",
                        display: 'block'
                      }}
                      />
                      {currentLang === 'fa' ? "عکس‌ها" : "Photos"}
                  </AttachmentItem>
                  <AttachmentItem isNight={isNight}>
                    <img
                      src={makePhoto}
                      alt="makePhoto"
                      style={{
                        width: 40,
                        marginLeft: 6,
                        marginRight: currentLang === 'fa' ? 0 : 8,
                        marginLeft: currentLang === 'fa' ? 8 : 0,
                        filter: isNight ? 'invert(1)' : 'none',
                        display: 'inline-block',
                        objectFit: 'contain',
                        direction: currentLang === "fa" ? "rtl" : "ltr",
                        textAlign: currentLang === "fa" ? "right" : "left",
                        display: 'block'
                      }}
                      />
                      {currentLang === 'fa' ? "دوربین" : "Camera"}
                  </AttachmentItem>
                  <AttachmentItem isNight={isNight} >
                    <img
                      src={files}
                      alt="files"
                      style={{
                        width: 45,
                        marginLeft: 6,
                        marginRight: currentLang === 'fa' ? 0 : 8,
                        marginLeft: currentLang === 'fa' ? 8 : 0,
                        filter: isNight ? 'invert(1)' : 'none',
                        display: 'inline-block',
                        objectFit: 'contain',
                        direction: currentLang === "fa" ? "rtl" : "ltr",
                        textAlign: currentLang === "fa" ? "right" : "left",
                        display: 'block'
                      }}
                      />
                      {currentLang === 'fa' ? "فایل‌ها" : "Files"}
                  </AttachmentItem>
                </AttachmentMenu>
              )}
            </AttachmentWrapper>
            <ToolWrapper>
              <ToolToggle ref={toolsButtonRef} onClick={() => setToolsOpen(prev => !prev)}>
                <img src={toolIcon} alt="tools" style={{ width: 23,objectFit: "contain",filter: isNight ? 'invert(1)' : 'none' }} />
              </ToolToggle>
              {toolsOpen && (
                <ToolMenu isNight={isNight} ref={toolsRef}>
                  <ToolItem isNight={isNight}>
                    <img
                      src={createImageIcon}
                      alt="creatImage"
                      style={{
                        width: 40,
                        marginLeft: 6,
                        filter: isNight ? 'invert(1)' : 'none',
                        display: 'inline-block',
                        objectFit: 'contain',
                        direction: currentLang === "fa" ? "rtl" : "ltr",
                        textAlign: currentLang === "fa" ? "right" : "left",
                        display: 'block'
                      }}
                    />
                    {currentLang === 'fa' ? "ساخت تصویر" : "Create an image"}
                  </ToolItem>
                  <ToolItem isNight={isNight}>
                    <img
                      src={psyIcon}
                      alt="psychology"
                      style={{
                        width: 40,
                        marginLeft: 6,
                        filter: isNight ? 'invert(1)' : 'none',
                        display: 'inline-block',
                        objectFit: 'contain',
                        direction: currentLang === "fa" ? "rtl" : "ltr",
                        textAlign: currentLang === "fa" ? "right" : "left",
                        display: 'block'
                      }}
                    />
                    {currentLang === 'fa' ? "روانشناسی" : "Psychology"}
                  </ToolItem>
          
                  <ToolItem isNight={isNight}>
                    <img
                      src={thinkIcon}
                      alt="websearch"
                      style={{
                        width: 40,
                        marginLeft: 6,
                        filter: isNight ? 'invert(1)' : 'none',
                        display: 'inline-block',
                        objectFit: 'contain',
                        direction: currentLang === "fa" ? "rtl" : "ltr",
                        textAlign: currentLang === "fa" ? "right" : "left",
                        display: 'block'
                      }}
                    />
                    {currentLang === 'fa' ? "تحلیل عمیق" : "Think for longer"}
                  </ToolItem>
                  <ToolItem isNight={isNight}>
                    <img
                      src={teachIcon}
                      alt="teach"
                      style={{
                        width: 40,
                        marginLeft: 6,
                        filter: isNight ? 'invert(1)' : 'none',
                        display: 'inline-block',
                        objectFit: 'contain',
                        direction: currentLang === "fa" ? "rtl" : "ltr",
                        textAlign: currentLang === "fa" ? "right" : "left",
                        display: 'block'
                      }}
                    />
                    {currentLang === 'fa' ? "آموزش و یادگیری" : "Teach & Learn"}
                  </ToolItem>
                  <ToolItem
                    ref={hobyButtonRef}
                    onClick={() => sethobyOpen(prev => !prev)}
                    isNight={isNight}
                    style={{position: 'relative'}}
                  >
                    <img
                          src={hobyIcon}
                          alt="hopy"
                          style={{
                            width: 40,
                            marginLeft: 6,
                            filter: isNight ? 'invert(1)' : 'none',
                            display: 'inline-block',
                            objectFit: 'contain',
                            direction: currentLang === "fa" ? "rtl" : "ltr",
                            textAlign: currentLang === "fa" ? "right" : "left",
                            display: 'block'
                          }}
                        />
                    {currentLang === 'fa' ? "سرگرمی‌ها" : "hobbies"}
                    {/* زیرمنو */}
                    {hobyOpen && (
                      <SubToolMenu isNight={isNight} ref={hobyRef}>
                        <ToolItem isNight={isNight} onClick={() => alert("Deep Search Clicked")}>
                          {currentLang === 'fa' ? "آهنگ" : "Music"}
                        </ToolItem>
                        <ToolItem isNight={isNight} onClick={() => alert("Deep Search Clicked")}>
                          {currentLang === 'fa' ? "فیلم" : "Movie"}
                        </ToolItem>
                        <ToolItem isNight={isNight} onClick={() => alert("Deep Search Clicked")}>
                          {currentLang === 'fa' ? "ورزش" : "Sport"}
                        </ToolItem>
                        <ToolItem isNight={isNight} onClick={() => alert("Deep Search Clicked")}>
                          {currentLang === 'fa' ? "اشپزی" : "Cooking"}
                        </ToolItem>
                      </SubToolMenu>
                    )}
                  </ToolItem>
                  
                  
                  <ToolItem
                    ref={searchWebButtonRef}
                    onClick={() => setsearchWebOpen(prev => !prev)}
                    isNight={isNight}
                    style={{position: 'relative'}}
                  >
                    <img
                          src={searchWebIcon}
                          alt="websearch"
                          style={{
                            width: 40,
                            marginLeft: 6,
                            filter: isNight ? 'invert(1)' : 'none',
                            display: 'inline-block',
                            objectFit: 'contain'
                          }}
                        />
                    {currentLang === 'fa' ? "جستجوی وب" : "Web Search"}
                    {/* زیرمنو */}
                    {searchWebOpen && (
                      <SubToolMenu isNight={isNight} ref={searchWebRef}>
                        <ToolItem isNight={isNight} onClick={() => alert("Deep Search Clicked")}>
                          <img src={deepSearchIcon} alt="deepSearch"
                            style={{width: 36, marginLeft: 6, filter: isNight ? 'invert(1)' : 'none'}}
                          />
                          {currentLang === 'fa' ? "جست‌وجوی عمیق" : "Deep Search"}
                        </ToolItem>
                      </SubToolMenu>
                    )}
                  </ToolItem>


                  <ToolItem isNight={isNight} onClick={() => setIsNight(!isNight)}>
                    <img
                      src={themIcon}
                      alt="them"
                      style={{
                        width: 40,
                        marginLeft: 6,
                        filter: isNight ? 'invert(1)' : 'none',
                        display: 'inline-block',
                        objectFit: 'contain'
                      }}
                    />
                    {currentLang === 'fa' ? "تغییر تم" : "Toggle Theme"}
                  </ToolItem>
                  <ToolItem isNight={isNight} ref={fontButtonRef} onClick={() => setFontMenuOpen(prev => !prev)} style={{ position: 'relative' }}>
                    <img
                      src={fontIcon}
                      alt="font"
                      style={{
                        width: 40,
                        marginLeft: 6,
                        filter: isNight ? 'invert(1)' : 'none',
                        display: 'inline-block',
                        objectFit: 'contain'
                      }}
                    />
                    {currentLang === 'fa' ? "انتخاب فونت" : "Choose Font"}
                    {fontMenuOpen && (
                      <FontMenu isNight={isNight} ref={fontMenuRef}>
                        {['Vazir','Great Vibes'].map((font) => (
                          <FontMenuItem
                          key={font}
                          isNight={isNight}
                          onClick={() => {
                            setSelectedFont(font);
                            setFontMenuOpen(false);
                            if (font === 'Vazir') setCurrentLang('fa');
                            else if (font === 'Great Vibes') setCurrentLang('en');
                          }}
                          >
                            {font}
                          </FontMenuItem>
                        ))}
                    
                      </FontMenu>
                    )}
                  </ToolItem>
                </ToolMenu>
              )}
            </ToolWrapper>

          </div>

          {/* Right side actions */}
          <div style={{ display: 'flex', gap: '0.7em' }}>
            <button style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              display: 'flex',
            }}>
              <img src={voiceChatIcon} alt="Headphone" style={{ width: 30,objectFit: "contain",filter: isNight ? 'invert(1)' : 'none' }} />
            </button>
            <button style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              display: 'flex',
              alignItems: 'flex-end'
            }}>
              <img src={voiceIcon} alt="Mic" style={{ width: 30,objectFit: "contain", filter: isNight ? 'invert(1)' : 'none' }} />
            </button>
            
          </div>
        </FooterActions>

      </InputWrapper>

      <LogoText style={{
        color: isNight ? '#fff' : '#000',
        fontSize: '1.2rem',
        marginTop: '0.2rem',
        marginBottom: '0',
        textAlign: 'center',
        fontFamily: "'Allura', cursive"
        }}>
        Yekta AI
      </LogoText>

    </Container>
  );
};

export default ChatWindow;
